import styled from 'styled-components';
import { withHoverSupport } from '../../constants';
import { isWhite } from '../../lib/utils/color';
const halfCircleBorderRadius = '50% 100%';
const borderPx = 1;
const getInnerDotSizeDimensions = (size) => {
    switch (size) {
        case 'medium':
            return { height: '1.25em', width: '1.25em' };
        case 'large':
            return { height: '2.375em', width: '2.375em' };
        default:
            return { height: '1em', width: '1em' };
    }
};
export const OuterDot = styled.div `
  ${o => !o.$disableOutline
    ? `
  border: ${borderPx}px solid
    ${o.$selected ? o.theme.color.deprecated.obsidian : 'transparent'};
  border-radius: 50%;`
    : null}
  box-sizing: border-box;
  flex: 0 0 auto;
  height: ${o => (o.$size === 'large' ? '3em' : '1.5em')};
  position: relative;
  width: ${o => (o.$size === 'large' ? '3em' : '1.5em')};
`;
export const Wrapper = styled.div `
  /* Default to a base font size of 16px for relative em units */
  font-size: 16px;
  outline: none;
  ${withHoverSupport} {
    &:hover {
      ${OuterDot} {
        border-color: ${o => (o.$hover ? o.theme.color.deprecated.obsidian : 'none')};
        cursor: pointer;
      }
    }
  }
`;
export const InnerDot = styled.div `
  background-color: ${o => deriveInnerDotBackgroundColor(o.$primaryColor, o.$secondaryColor)};
  background-image: ${o => o.$swatchUrl && `url("${o.$swatchUrl}")`};
  background-size: contain;
  border-radius: 50%;
  box-sizing: border-box;
  height: ${o => getInnerDotSizeDimensions(o.$size).height};
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: ${o => getInnerDotSizeDimensions(o.$size).width};

  &::after {
    border-bottom: ${o => (o.$unavailable || o.$disabled) &&
    `${borderPx}px solid ${(o.$selected && isWhite(o.$primaryColor)) || isWhite(o.$secondaryColor) ? 'black' : 'white'}`};
    box-sizing: border-box;
    content: '';
    display: block;
    height: 1px;
    left: -${borderPx}px;
    position: absolute;
    top: calc(50% - ${borderPx}px);
    transform: rotateZ(-45deg);
    transform-origin: bottom;
    width: calc(100% + ${2 * borderPx}px);
  }
`;
export const SelectedIconWrap = styled.span `
  display: ${o => (o.$selected ? 'inline-block' : 'none')};
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
`;
export const HalfDot = styled.div `
  background-color: ${o => o.$bgColor ?? o.theme.color.deprecated.obsidian};
  border-style: solid;
  border-color: ${o => (isWhite(o.$bgColor) ? o.theme.color.deprecated.stone : 'transparent')};
  box-sizing: border-box;
  height: 50%;
  width: 100%;

  &:nth-child(1) {
    border-width: 1px 1px 0 1px;
    border-top-left-radius: ${halfCircleBorderRadius};
    border-top-right-radius: ${halfCircleBorderRadius};
  }

  &:nth-child(2) {
    border-width: 0 1px 1px 1px;
    border-bottom-left-radius: ${halfCircleBorderRadius};
    border-bottom-right-radius: ${halfCircleBorderRadius};
  }
`;
export const HalfDotWrap = styled.span `
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 0;
  inset: 0;
`;
function deriveInnerDotBackgroundColor(primaryColor, secondaryColor) {
    return primaryColor && (!secondaryColor || primaryColor === secondaryColor)
        ? primaryColor
        : 'transparent';
}
//# sourceMappingURL=styles.js.map